import http from '@/utils/http';
import {
  normalizeUrlCollectionItem,
  sortUrlCollectionItems,
  sanitizeUrlCollectionItemsForSave,
} from '@home/utils/urlCollectionData';

import type {
  IFetchUrlCollectionsParams,
  IFetchUrlCollectionsResponse,
  IUpdateUrlCollectionsParams,
  IUpdateUrlCollectionsResponse,
} from '@home/types/urlCollection';

const formatShortcutItems = (shortcuts: any[]) => {
  return sortUrlCollectionItems(shortcuts.map((item) => normalizeUrlCollectionItem(item)));
};

export const fetchUrlCollections = (params: IFetchUrlCollectionsParams): Promise<IFetchUrlCollectionsResponse> => {
  return http({
    url: '/api/v1/intelligence_pc/shortcuts/query',
    method: 'post',
    errorHandler: true,
    data: params,
    formatData: (data: any) => {
      const shortcuts = Array.isArray(data?.shortcuts) ? data.shortcuts : [];

      return {
        shortcuts: formatShortcutItems(shortcuts),
      };
    },
  }) as Promise<IFetchUrlCollectionsResponse>;
};

export const updateUrlCollections = (params: IUpdateUrlCollectionsParams): Promise<IUpdateUrlCollectionsResponse> => {
  return http({
    url: '/api/v1/intelligence_pc/shortcuts/save',
    method: 'post',
    errorHandler: true,
    data: {
      ...params,
      shortcuts: sanitizeUrlCollectionItemsForSave(params.shortcuts || []),
    },
    formatData: (data: any) => {
      const shortcuts = Array.isArray(data?.shortcuts) ? data.shortcuts : [];

      return {
        shortcuts: formatShortcutItems(shortcuts),
      };
    },
  }) as Promise<IUpdateUrlCollectionsResponse>;
};
